export const TestId = {
  EXPOSE_HEADER_PRO: 'expose-header-pro',
  EXPOSE_HEADER_BASIC: 'expose-header-basic',
  REAL_ESTATE_AGENT_STRUCTURED_DATA: 'real-estate-agent-structured-data',
};
